<ng-container>
  <markant-platform-ui-page-header>
    {{ 'dashboard.cartridge.overviewHeadline' | transloco }}
  </markant-platform-ui-page-header>

  <ng-container *ngIf="tableParams$ | async as tableParams">
    <div class="action-bar">
      <markant-input
        class="search"
        data-cy="input-cartridge-search-field"
        [search]="true"
        [debounce]="300"
        [useCustomLayout]="true"
        [placeholder]="'cartridge.searchLabel' | transloco"
        [value]="tableParams.searchQuery"
        (valueChange)="onSearchChange($event.detail)"
      >
      </markant-input>
    </div>

    <markant-platform-table
      [data]="tableData$ | async"
      [defaultHeaderCells]="tableDraft.headerAndTableCells"
      [loading]="(isLoading$ | async) || false"
      [showPagination]="false"
      (sortChanged)="onSortChange($event)"
    >
    </markant-platform-table>
  </ng-container>
</ng-container>
